import React, { useState } from "react";
import { Col } from "react-bootstrap";
import { DownOutlined, PaperClipOutlined } from '@ant-design/icons';
import { Button, Dropdown } from 'antd';
import ReactLoading from "react-loading";
import { useReactToPrint } from "react-to-print";


import "./Buttons.css";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import html2pdf from "html2pdf.js";
function BtnPrintWithPageBreak({ size, divId, fileName, data }) {
  const [isClicked, setIsClicked] = useState(false);
  const items = [
    {
      label: 'A5',
      key: 'a5',
      icon: <PaperClipOutlined />,
    },
    {
      label: 'A4',
      key: 'a4',
      icon: <PaperClipOutlined />,
    },
    {
      label: 'Letter',
      key: 'letter',
      icon: <PaperClipOutlined />,
    },
    {
      label: 'Legal',
      key: 'legal',
      icon: <PaperClipOutlined />,
    },
  ];

  // const handlePrint = async (e) => {
  //   setIsClicked(true);
  //   const input = divId.current;
    
  //   const options = {
  //     margin: 7,
  //     filename: fileName,
  //     image: { type: "jpeg", quality: 0.98 },
  //     html2canvas: { scale: 2 },
  //     jsPDF: { unit: "mm", format: e?.key, orientation: "portrait" },
  //     pagebreak: { mode: "css", before: "#pageBreak" },
  //   };
  
  //   html2pdf()
  //   .set(options)
  //   .from(input)
  //   .toPdf()
  //   .get("pdf")
  //   .then((pdf) => {
  //     const blob = pdf.output("blob");
  //     const url = URL.createObjectURL(blob);
  //     const newTab = window.open(url);
      
  //     if (newTab) {
  //       newTab.onload = () => {
  //         newTab.print(); // Auto print after opening
  //       };
  //     } else {
  //       alert("Popup blocked! Please allow popups and try again.");
  //     }
  //   })
  //   .save()
  //   .then(() => {
  //     setIsClicked(false);
  //   });
  // };

  const handlePrint = async (e) => {
    setIsClicked(true);
    const input = divId.current;
  
    const options = {
      margin: [7, 8.5, 21, 8.5], // [top, left, bottom, right]
      filename: fileName,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "mm", format: e?.key, orientation: "portrait" },
      pagebreak: { mode: "css", before: "#pageBreak" },
    };
  
    html2pdf()
      .set(options)
      .from(input)
      .toPdf()
      .get("pdf")
      .then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();
        const assessmentNo = data?.id; // Get assessment number
  
        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);
          pdf.setFontSize(9);
          pdf.setFont("times", "italic");
          pdf.text(
            `Page ${i} of Assessment No. ${assessmentNo}`,
            pdf.internal.pageSize.getWidth() - 50,
            pdf.internal.pageSize.getHeight() - 10
          );
        }
  
        // Save the PDF directly (download without new tab)
        // pdf.save(fileName);
  
        // Print the PDF without opening a new tab
        const blob = pdf.output("bloburl");
        const iframe = document.createElement("iframe");
        iframe.style.display = "none";
        iframe.src = blob;
        document.body.appendChild(iframe);
  
        iframe.onload = () => {
          iframe.contentWindow.focus();
          iframe.contentWindow.print();
        };
      })
      .then(() => {
        setIsClicked(false);
      });
  };
  

  const menuProps = {
    items,
    onClick: (e) => handlePrint(e),
  };

  return (
    <Col>
      {isClicked ? (
        <Button className="action-btn clear loader" size={size}>
          <ReactLoading type={"balls"} height={20} width={25} color="#2d6e5e" />
        </Button>
      ) : (
        <Dropdown menu={menuProps}>
          <Button className="action-btn clear" size={size}>
              Print
              <DownOutlined />
          </Button>
        </Dropdown>
      )}
    </Col>
  );
}

export default BtnPrintWithPageBreak;
